export default __webpack_public_path__ + "static/media/defaultItemIcon.53c8e13f.png";